import { getEmojiByAnimalName } from "@jugl-web/utils/animalsEmoji";

/**
 * If anonymous, attempt to extract the animal emoji.
 * Otherwise, return the conversation name.
 */
export const getConversationUsername = (conversationName: string) => {
  const anonymousUsernameRegex = /Anonymous\s+(.*)/; // "Anonymous Cat" for example

  const match = conversationName.match(anonymousUsernameRegex);

  if (!match) {
    return conversationName;
  }

  const animalName = match[1];
  const animalEmoji = getEmojiByAnimalName(animalName);

  if (!animalEmoji) {
    return conversationName;
  }

  return animalEmoji;
};
